@if (summary$ | async; as summary) {
    <div class="acca-boost-winnings">
        <div class="acca-boost-icon" [class.acca-boost-icon-enhanced]="isEnhancedLayoutEnabled">
            <bs-acca-boost-icon [iconSize]="accaBoostTitleIconSize" />
        </div>
        <span class="acca-boost-winnings__title" [class.acca-boost-winnings__title-enhanced]="isEnhancedLayoutEnabled">{{
            sitecore.accaBoost.AccaBoost
        }}</span>
    </div>
    <div [class.acca-boost-winnings-summary-enhanced]="isEnhancedLayoutEnabled">
        <span class="acca-boost-winnings__stake"
            >{{ summary.stake | bsCurrency: true }} {{ returnsMessage() }} {{ sitecore.accaBoost.WinningsReturns }}</span
        >
        <span class="acca-boost-winnings__return"> {{ summary.winnings | bsCurrency: true }}</span>
        <span class="acca-boost-winnings__boosted-return" [class.acca-boost-winnings__boosted-return-enhanced]="isEnhancedLayoutEnabled">
            <vn-icon class="acca-boost-icon" [name]="accaBoostIcon.name" [size]="accaBoostIcon.size" />
            <span class="acca-boost-winnings__boosted-return-value">{{ summary.boostedWinnings | bsCurrency: true }} </span>
        </span>
    </div>
}
